import { Component, OnInit, HostListener } from '@angular/core';
import { RegisterVM, CountryVM, NationalityVM, GlobalSettingsVM, RegistrationResponse, CallingCodeVM } from '../../../models';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { SignupService } from '../../../services/signup.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../base/base.component';
import { Utils, minAgeValidator } from '../../../utils/utils';
import { formatMobileNumber, mobileNumberValidator, parseMobileNumber } from '../../../utils/mobile-number';
import * as moment from 'moment';

@Component({
  selector: 'signup-step3',
  templateUrl: './step3.component.html'
})
export class Step3Component extends BaseComponent implements OnInit {

  myModel: RegisterVM;
  signupStatus: boolean | null = null;
  signupError: string = '';
  tcChecked: boolean = false;
  mobileCallingCode: CallingCodeVM;
  mobileLocalNumber: string = '';
  countryDropdownOpen: boolean = false;
  countryDropdownElement: HTMLElement = null;

  dropdownLeft = 0;
  dropdownTop = 0;
  dropdownWidth = 0;

  constructor(private signupService: SignupService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router) {
    super(route);
    this.myModel = signupService.model;
  }

  ngOnInit(): void {

    let charsOnlyRegEx = new RegExp(/^([^0-9]*)$/);
    //Using form builder to create form validations
    this.myForm = this.fb.group({
      firstname: new FormControl(null, [Validators.required, Validators.pattern(charsOnlyRegEx)]),
      lastname: new FormControl(null, [Validators.required, Validators.pattern(charsOnlyRegEx)]),
      displayName: new FormControl(null, [Validators.required, Validators.pattern(charsOnlyRegEx)]),
      dob: new FormGroup({}),
      age: new FormControl(null),
      gender: new FormControl('', [Validators.required]),
      nationality: new FormControl(null, [Validators.required]),
      mobileCallingCode: new FormControl(null, [Validators.required]),
      mobile: new FormControl(null, [Validators.required, mobileNumberValidator(() => this.mobileCallingCode)]),
      addressLine1: new FormControl(null, [Validators.required]),
      addressLine2: new FormControl(null),
      city: new FormControl(null, [Validators.required]),
      postcode: new FormControl(null, [Validators.required]),
      country: new FormControl(null, [Validators.required]),
      state: new FormControl(null),
      tcChecked: new FormControl(''),
    });
    this.setMobileFieldsFromModel();

  }

  onSubmit(value: string): void {
    this.markAsTouched(this.myForm);
    this.updateModelMobile();

    if (this.myModel.dateOfBirth == null) {
      return;
    }

    if (this.myForm.valid) {
      this.emitDisplayLoadingDialog(true);
      this.signupService.signup()
        .subscribe(
          returnValue => this.checkRegistrationResp(returnValue),
          error => this.showDialog(error + " Error, please try again", true),
          () => { this.emitDisplayLoadingDialog(false); }
        );
    }
  }

  checkRegistrationResp(value: any) {
    if (value != null) {
      this.signupService.resendToken = value;
      this.router.navigateByUrl('/signup-4');
    }
    else {
      this.showDialog(value + " Error, please try again", true);
    }
  }

  dateSelected(dob: string) {
    this.myModel.dateOfBirth = dob;
  }

  onMobileCallingCodeChange() {
    this.myForm.controls['mobile'].updateValueAndValidity();
    this.updateModelMobile();
  }

  onMobileNumberChange() {
    this.updateModelMobile();
  }

  private setMobileFieldsFromModel() {
    const mobileNumber = parseMobileNumber(this.myModel.mobile, this.callingCodeList);
    this.mobileCallingCode = mobileNumber.callingCode;
    this.mobileLocalNumber = mobileNumber.localNumber;

    this.myForm.controls['mobileCallingCode'].setValue(this.mobileCallingCode);
    this.myForm.controls['mobile'].setValue(this.mobileLocalNumber);
  }

  private updateModelMobile() {
    this.myModel.mobile = formatMobileNumber(this.mobileCallingCode, this.mobileLocalNumber);
  }

  toggleCountryDropdown(event: MouseEvent): void {
    event.stopPropagation();
    this.countryDropdownElement = event.currentTarget as HTMLElement;
    this.countryDropdownOpen = !this.countryDropdownOpen;
    if (this.countryDropdownOpen) {
      this.positionCountryDropdown();
    }
  }

  selectCallingCode(item: CallingCodeVM, event: MouseEvent): void {
    event.stopPropagation();

    this.mobileCallingCode = item;

    this.myForm.controls['mobileCallingCode'].setValue(item);
    this.myForm.controls['mobileCallingCode'].markAsTouched();

    this.onMobileCallingCodeChange();

    this.countryDropdownOpen = false;
  }

  private positionCountryDropdown(): void {
    if (!this.countryDropdownOpen) {
      return;
    }

    const rect = this.countryDropdownElement.getBoundingClientRect();

    this.dropdownLeft = rect.left;
    this.dropdownTop = rect.bottom;
    this.dropdownWidth = rect.width;
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    if (this.countryDropdownOpen) {
      this.positionCountryDropdown();
    }
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    if (this.countryDropdownOpen) {
      this.positionCountryDropdown();
    }
  }

  @HostListener('document:click')
  closeCountryDropdown(): void {
    this.countryDropdownOpen = false;
  }

}
